
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2397',
  depVersions: {
  "customer-portal-app": "static-1.2397",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.469",
  "data-fetching-client": "static-1.9696",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.25460",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5620",
  "hs-test-utils": "static-1.8043",
  "hub-http": "static-1.6251",
  "hub-http-shared-msw-handlers": "static-1.10032",
  "hubspot-dlb": "static-2.1854",
  "hubspot-prosemirror": "static-1.18311",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11501",
  "I18n": "static-7.1631",
  "immutable": "static-2.79",
  "jasmine-runner": "static-1.6493",
  "payment-link-components": "static-1.23620",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7067",
  "quartz-core": "static-1.6286",
  "quartz-i18n": "static-1.742",
  "react": "static-7.186",
  "react-colorpicker": "static-2.10237",
  "react-dlb": "static-1.79",
  "react-utils": "static-2.5367",
  "rich-text-lib": "static-1.19881",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18039",
  "ui-components-test-utils": "static-1.5638",
  "UIComponents": "static-3.8447",
  "foundations-assets": "static-1.4897",
  "foundations-components": "static-1.7992",
  "foundations-theming": "static-1.4449",
  "foundations-theming-specialty": "static-1.2165",
  "framer-motion": "static-1.72",
  "metrics-js": "static-1.9637",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.940",
  "quartz-config": "static-1.845",
  "quartz-routing": "static-1.497",
  "quick-fetch": "static-1.3939",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1-feature-id-1459-skip-old-browsers.3",
  "rpc-client-utils": "static-1.4681",
  "sanitize-text": "static-1.8172",
  "styled-components": "static-2.89",
  "tanstack-table": "static-1.55",
  "ui-addon-draggable": "static-3.4792",
  "ui-addon-react-router-dom": "static-1.9571",
  "usage-tracker": "static-1.7377",
  "usage-tracker-anonymous": "static-1.5794",
  "usage-tracker-core": "static-1.7227",
  "video-components-external": "static-1.11379",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3421",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3344",
  "quartz-webpack": "static-1.3291",
  "bend-plugin-quartz-routing": "static-1.145",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.82",
  "customer-data-objects": "static-1.7702",
  "frontend-preferences-client": "static-1.7956",
  "laboratory-lib": "static-3.7185",
  "onboarding-scopes": "static-1.6490",
  "seat-types-lib": "static-1.78",
  "ui-addon-opt": "static-4.8393",
  "HeadJS": "static-2.764",
  "hs-test-utils-bend-plugin": "static-1.3154",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "hs-locale-management": "static-1.103",
  "ts-schema": "static-1.4103",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7795",
  "cssUtils": "static-1.798",
  "customer-data-ui-utilities": "static-1.9855",
  "HubStyle": "static-2.11808",
  "knowledge-content-types": "static-1.8501",
  "PatternValidationJS": "static-1.437",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.487",
  "ui-addon-emoji-picker": "static-1.9917",
  "ui-addon-i18n": "static-1.11178",
  "ui-business-units-lib": "static-1.9085",
  "ui-shepherd-react": "static-3.10200",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4356",
  "commerce-tours-lib": "static-1.6155",
  "customer-data-properties": "static-1.51668",
  "getting-started-shared-tasks": "static-1.18528",
  "growth-onboarding-reliability": "static-1.5111",
  "onboarding-tours": "static-1.16668",
  "reference-resolvers-lite": "static-1.8124",
  "sales-checkout-service-client": "static-1.3671",
  "ui-addon-iframeable": "static-1.9090",
  "user-context": "static-1.5134",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.838",
  "hubspotter-http": "static-1.4674",
  "icons": "static-2.650",
  "mobile-manifest-mixins": "static-1.538",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.742",
  "quartz-head": "static-1.732",
  "quartz-test": "static-1.742",
  "quartz-tracking": "static-1.446",
  "ui-fonts": "static-1.763",
  "usage-tracker-container": "static-1.7367",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9453",
  "data-token-picker": "static-1.16455",
  "FileManagerLib": "static-1.39340",
  "property-translator": "static-1.5428",
  "atom": "static-1.5102",
  "merchandise-lib": "static-1.264",
  "purchase-motions-components": "static-1.5970",
  "salesImages": "static-1.525",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5475",
  "react-select-plus": "static-1.105",
  "react-virtualized": "static-2.99",
  "ui-images": "static-2.1160",
  "bend-plugin-foundations-components": "static-1.4261",
  "floating-ui": "static-1.56",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.29",
  "trellis-assets": "static-1.2030",
  "bend-plugin-foundations-theming": "static-1.2932",
  "foundations-theming-base": "static-1.3434",
  "stylex": "static-1.33",
  "interframe": "static-3.4789",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5791",
  "web-vitals": "static-1.6",
  "bend-plugin-chirp-manifest": "static-1.91",
  "chirp-fetch": "static-1.1917",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4505",
  "react-flip-move": "static-1.70",
  "apollo-link-hub-http": "static-2.4681",
  "content-media-composition-data-lib": "static-1.12424",
  "content-media-compositions": "static-2.16431",
  "idb-keyval": "static-1.44",
  "immer": "static-1.33",
  "immerable": "static-1.4183",
  "magpie-lib": "static-1.5571",
  "magpie-types": "static-1.5031",
  "media-bridge-lib": "static-1.18974",
  "video-data-lib": "static-1.35037",
  "bender-build-tools": "static-1.3215",
  "inbound-db-properties-service-client": "static-1.3869",
  "superstore": "static-1.4790",
  "feedback-loader": "static-1.29348",
  "ai-components-ui-library": "static-1.9042",
  "ui-addon-video-player": "static-1.8732",
  "ui-coaching-tips": "static-1.28640",
  "sassPrefix": "static-1.156",
  "react-dnd-compat": "static-1.4644",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2527",
  "navigation-messaging": "static-1.7440",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8200",
  "reselect": "static-2.16",
  "commerce-products-lib": "static-1.9670",
  "crm-message-bus": "static-1.43040",
  "growth-data-modal": "static-1.5472",
  "hubspot-apollo-client": "static-1.4908",
  "onboarding-tours-client": "static-1.4882",
  "calling-global-api": "static-1.64611",
  "calling-internal-common": "static-1.31331",
  "calling-lifecycle-internal": "static-1.65993",
  "calling-lifecycle-messages": "static-1.58286",
  "conditional-properties-service-client": "static-1.3820",
  "crm-links": "static-1.6324",
  "customer-data-objects-ui-components": "static-1.13058",
  "customer-data-properties-shared-msw-handlers": "static-1.9359",
  "customer-data-property-utils": "static-1.8120",
  "external-options-client-types": "static-1.4182",
  "file-manager-components": "static-1.23700",
  "framework-data-schema-resolvers": "static-1.6914",
  "google-libphonenumber": "static-1.38",
  "hs-resources": "static-1.185",
  "inbound-db-meta-service-client": "static-1.3609",
  "inbounddb-objects-service-types": "static-1.4246",
  "meetings-icalendar-utils-lib": "static-1.661",
  "multi-currency-client-types": "static-1.3714",
  "object-builder-ui-client": "static-1.48837",
  "pipeline-validation-client-types": "static-1.3988",
  "property-value-citations": "static-1.2282",
  "pulse": "static-1.609",
  "smart-property-lib": "static-1.7230",
  "tiered-pricing": "static-1.1280",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11019",
  "growth-onboarding-confetti": "static-1.3096",
  "growth-onboarding-next-action-utils": "static-1.2002",
  "navigation-components": "static-1.18113",
  "onboarding-tours-utils": "static-1.734",
  "ui-shepherd-tracker": "static-1.7581",
  "ui-universal-auth": "static-1.9012",
  "batch-promise": "static-1.1571",
  "getting-started-shared-tasks-store": "static-1.17646",
  "hubspotter-http-shared-msw-handlers": "static-1.10030",
  "usage-tracker-session-replay": "static-1.5063",
  "audio-components": "static-1.5958",
  "FileManagerCore": "static-1.39199",
  "FileManagerImages": "static-1.36851",
  "video-components": "static-1.13382",
  "foundations-components-legacy": "static-1.1017",
  "purchase-motions-api": "static-1.5973",
  "signup-constants": "static-1.18897",
  "signup-ui-url-generator": "static-2.8082",
  "usage-tracker-public": "static-1.7188",
  "reactive-lib": "static-1.752",
  "simple-logging-lib": "static-1.3080",
  "chatspot-core": "static-1.21415",
  "ContentUtils": "static-1.68450",
  "copilot-toolkit": "static-1.11206",
  "growth-onboarding-feedback-components": "static-1.6609",
  "commerce-permissions": "static-1.800",
  "customer-data-tracking": "static-1.6919",
  "products-iframe-lib": "static-1.8016",
  "products-ui-components-shared-msw-handlers": "static-1.10414",
  "restore-request-side-panel-lib": "static-1.976",
  "onboarding-data-sync-lib": "static-1.2001",
  "hubspot-apollo-cache": "static-1.367",
  "calling-error-reporting": "static-1.31338",
  "shared-worker-versioning": "static-1.11066",
  "calling-usage-tracker": "static-1.6570",
  "self-service-api": "static-1.10277",
  "voice-sms-access-library": "static-1.1099",
  "conversations-skeleton-state": "static-1.7277",
  "location-customization-utils-lib": "static-1.9347",
  "crm-pipelines-api-client-types": "static-1.4162",
  "fdsr-migration-layer": "static-1.33",
  "framework-builder-read-service-client": "static-1.4028",
  "framework-data-schema-quick-fetch": "static-1.6819",
  "persist-promise": "static-1.3728",
  "bend-plugin-pulse": "static-1.112",
  "event-emitter": "static-1.977",
  "fast-json-patch": "static-1.63",
  "data-agent-kit": "static-1.239",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10115",
  "fsm": "static-1.3761",
  "policy-lib": "static-1.6806",
  "react-tinymce": "static-1.55324",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10178",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54450",
  "tinymce-plugins": "static-1.57564",
  "tinymce-themes": "static-1.56420",
  "growth-onboarding-next-action-components": "static-1.2030",
  "user-context-client": "static-1.4641",
  "nest": "static-1.259",
  "unified-auth-core-lib": "static-1.808",
  "amplitude-session-replay-browser": "static-1.60",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4566",
  "video-embed": "static-1.35871",
  "content-icons-ui": "static-1.2233",
  "social-insights-client-types": "static-1.22191",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4841",
  "integrations-lib": "static-1.16250",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4288",
  "InboxConnectUtils": "static-4.14894",
  "meetings-connect-utils-lib": "static-1.7634",
  "calling-orchestration-schema": "static-1.35876",
  "crm-record-cards-service-types": "static-1.3615",
  "highcharts": "static-8.104",
  "trellis-story-utils": "static-1.4544",
  "storybook-react": "static-1.33",
  "hub-http-contrib": "static-1.3071",
  "tinymce-data": "static-1.40535",
  "ui-addon-sales-email": "static-1.5240",
  "codemirror": "static-5.95",
  "layout-dnd-components": "static-1.12498",
  "layout-dnd-utils": "static-1.11473",
  "react-codemirror": "static-1.10655",
  "ui-brand-identity-lib": "static-1.15405",
  "NamespacedHubStyle": "static-2.9081",
  "outpost": "static-1.4207",
  "flux-actions": "static-1.341",
  "integrations-error-boundary-lib": "static-1.13665",
  "integrations-tracking-lib": "static-1.5631",
  "native-integrations-shared-strings": "static-1.7811",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10395",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.526",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68525",
  "layout-data-lib": "static-1.9798",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.3042",
  "google-sheets-integration-lib": "static-1.322",
  "microsoft-drive-integration-lib": "static-1.446",
  "slack-ui-library": "static-1.10421",
  "advanced-menus-core": "static-1.15172",
  "advanced-menus-lib": "static-1.12110",
  "ExportDialog": "static-6.10413",
  "ui-memberships-settings-lib": "static-1.34125",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15171",
  "simple-menus-lib": "static-1.16688"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2397",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.469",
  "data-fetching-client": "/data-fetching-client/static-1.9696",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.25460",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5620",
  "hs-test-utils": "/hs-test-utils/static-1.8043",
  "hub-http": "/hub-http/static-1.6251",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10032",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18311",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11501",
  "I18n": "/I18n/static-7.1631",
  "immutable": "/immutable/static-2.79",
  "jasmine-runner": "/jasmine-runner/static-1.6493",
  "payment-link-components": "/payment-link-components/static-1.23620",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7067",
  "quartz-core": "/quartz-core/static-1.6286",
  "quartz-i18n": "/quartz-i18n/static-1.742",
  "react": "/react/static-7.186",
  "react-colorpicker": "/react-colorpicker/static-2.10237",
  "react-dlb": "/react-dlb/static-1.79",
  "react-utils": "/react-utils/static-2.5367",
  "rich-text-lib": "/rich-text-lib/static-1.19881",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18039",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5638",
  "UIComponents": "/UIComponents/static-3.8447",
  "foundations-assets": "/foundations-assets/static-1.4897",
  "foundations-components": "/foundations-components/static-1.7992",
  "foundations-theming": "/foundations-theming/static-1.4449",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2165",
  "framer-motion": "/framer-motion/static-1.72",
  "metrics-js": "/metrics-js/static-1.9637",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.940",
  "quartz-config": "/quartz-config/static-1.845",
  "quartz-routing": "/quartz-routing/static-1.497",
  "quick-fetch": "/quick-fetch/static-1.3939",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1-feature-id-1459-skip-old-browsers.3",
  "rpc-client-utils": "/rpc-client-utils/static-1.4681",
  "sanitize-text": "/sanitize-text/static-1.8172",
  "styled-components": "/styled-components/static-2.89",
  "tanstack-table": "/tanstack-table/static-1.55",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4792",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9571",
  "usage-tracker": "/usage-tracker/static-1.7377",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5794",
  "usage-tracker-core": "/usage-tracker-core/static-1.7227",
  "video-components-external": "/video-components-external/static-1.11379",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3421",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3344",
  "quartz-webpack": "/quartz-webpack/static-1.3291",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.145",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.82",
  "customer-data-objects": "/customer-data-objects/static-1.7702",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7956",
  "laboratory-lib": "/laboratory-lib/static-3.7185",
  "onboarding-scopes": "/onboarding-scopes/static-1.6490",
  "seat-types-lib": "/seat-types-lib/static-1.78",
  "ui-addon-opt": "/ui-addon-opt/static-4.8393",
  "HeadJS": "/HeadJS/static-2.764",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3154",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "hs-locale-management": "/hs-locale-management/static-1.103",
  "ts-schema": "/ts-schema/static-1.4103",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7795",
  "cssUtils": "/cssUtils/static-1.798",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9855",
  "HubStyle": "/HubStyle/static-2.11808",
  "knowledge-content-types": "/knowledge-content-types/static-1.8501",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9917",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11178",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9085",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10200",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4356",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6155",
  "customer-data-properties": "/customer-data-properties/static-1.51668",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18528",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5111",
  "onboarding-tours": "/onboarding-tours/static-1.16668",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8124",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3671",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9090",
  "user-context": "/user-context/static-1.5134",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.838",
  "hubspotter-http": "/hubspotter-http/static-1.4674",
  "icons": "/icons/static-2.650",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.538",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.742",
  "quartz-head": "/quartz-head/static-1.732",
  "quartz-test": "/quartz-test/static-1.742",
  "quartz-tracking": "/quartz-tracking/static-1.446",
  "ui-fonts": "/ui-fonts/static-1.763",
  "usage-tracker-container": "/usage-tracker-container/static-1.7367",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9453",
  "data-token-picker": "/data-token-picker/static-1.16455",
  "FileManagerLib": "/FileManagerLib/static-1.39340",
  "property-translator": "/property-translator/static-1.5428",
  "atom": "/atom/static-1.5102",
  "merchandise-lib": "/merchandise-lib/static-1.264",
  "purchase-motions-components": "/purchase-motions-components/static-1.5970",
  "salesImages": "/salesImages/static-1.525",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5475",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-virtualized": "/react-virtualized/static-2.99",
  "ui-images": "/ui-images/static-2.1160",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4261",
  "floating-ui": "/floating-ui/static-1.56",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.29",
  "trellis-assets": "/trellis-assets/static-1.2030",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2932",
  "foundations-theming-base": "/foundations-theming-base/static-1.3434",
  "stylex": "/stylex/static-1.33",
  "interframe": "/interframe/static-3.4789",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5791",
  "web-vitals": "/web-vitals/static-1.6",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.91",
  "chirp-fetch": "/chirp-fetch/static-1.1917",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4505",
  "react-flip-move": "/react-flip-move/static-1.70",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4681",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12424",
  "content-media-compositions": "/content-media-compositions/static-2.16431",
  "idb-keyval": "/idb-keyval/static-1.44",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4183",
  "magpie-lib": "/magpie-lib/static-1.5571",
  "magpie-types": "/magpie-types/static-1.5031",
  "media-bridge-lib": "/media-bridge-lib/static-1.18974",
  "video-data-lib": "/video-data-lib/static-1.35037",
  "bender-build-tools": "/bender-build-tools/static-1.3215",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3869",
  "superstore": "/superstore/static-1.4790",
  "feedback-loader": "/feedback-loader/static-1.29348",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9042",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8732",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28640",
  "sassPrefix": "/sassPrefix/static-1.156",
  "react-dnd-compat": "/react-dnd-compat/static-1.4644",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2527",
  "navigation-messaging": "/navigation-messaging/static-1.7440",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8200",
  "reselect": "/reselect/static-2.16",
  "commerce-products-lib": "/commerce-products-lib/static-1.9670",
  "crm-message-bus": "/crm-message-bus/static-1.43040",
  "growth-data-modal": "/growth-data-modal/static-1.5472",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4908",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4882",
  "calling-global-api": "/calling-global-api/static-1.64611",
  "calling-internal-common": "/calling-internal-common/static-1.31331",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65993",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58286",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3820",
  "crm-links": "/crm-links/static-1.6324",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13058",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9359",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8120",
  "external-options-client-types": "/external-options-client-types/static-1.4182",
  "file-manager-components": "/file-manager-components/static-1.23700",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6914",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "hs-resources": "/hs-resources/static-1.185",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3609",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4246",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.661",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3714",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48837",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3988",
  "property-value-citations": "/property-value-citations/static-1.2282",
  "pulse": "/pulse/static-1.609",
  "smart-property-lib": "/smart-property-lib/static-1.7230",
  "tiered-pricing": "/tiered-pricing/static-1.1280",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11019",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3096",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2002",
  "navigation-components": "/navigation-components/static-1.18113",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.734",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7581",
  "ui-universal-auth": "/ui-universal-auth/static-1.9012",
  "batch-promise": "/batch-promise/static-1.1571",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17646",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10030",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5063",
  "audio-components": "/audio-components/static-1.5958",
  "FileManagerCore": "/FileManagerCore/static-1.39199",
  "FileManagerImages": "/FileManagerImages/static-1.36851",
  "video-components": "/video-components/static-1.13382",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1017",
  "purchase-motions-api": "/purchase-motions-api/static-1.5973",
  "signup-constants": "/signup-constants/static-1.18897",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8082",
  "usage-tracker-public": "/usage-tracker-public/static-1.7188",
  "reactive-lib": "/reactive-lib/static-1.752",
  "simple-logging-lib": "/simple-logging-lib/static-1.3080",
  "chatspot-core": "/chatspot-core/static-1.21415",
  "ContentUtils": "/ContentUtils/static-1.68450",
  "copilot-toolkit": "/copilot-toolkit/static-1.11206",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6609",
  "commerce-permissions": "/commerce-permissions/static-1.800",
  "customer-data-tracking": "/customer-data-tracking/static-1.6919",
  "products-iframe-lib": "/products-iframe-lib/static-1.8016",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10414",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.976",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2001",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.367",
  "calling-error-reporting": "/calling-error-reporting/static-1.31338",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11066",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6570",
  "self-service-api": "/self-service-api/static-1.10277",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1099",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7277",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9347",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4162",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.33",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4028",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6819",
  "persist-promise": "/persist-promise/static-1.3728",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.112",
  "event-emitter": "/event-emitter/static-1.977",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "data-agent-kit": "/data-agent-kit/static-1.239",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10115",
  "fsm": "/fsm/static-1.3761",
  "policy-lib": "/policy-lib/static-1.6806",
  "react-tinymce": "/react-tinymce/static-1.55324",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10178",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54450",
  "tinymce-plugins": "/tinymce-plugins/static-1.57564",
  "tinymce-themes": "/tinymce-themes/static-1.56420",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2030",
  "user-context-client": "/user-context-client/static-1.4641",
  "nest": "/nest/static-1.259",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.808",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4566",
  "video-embed": "/video-embed/static-1.35871",
  "content-icons-ui": "/content-icons-ui/static-1.2233",
  "social-insights-client-types": "/social-insights-client-types/static-1.22191",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4841",
  "integrations-lib": "/integrations-lib/static-1.16250",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4288",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14894",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7634",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35876",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3615",
  "highcharts": "/highcharts/static-8.104",
  "trellis-story-utils": "/trellis-story-utils/static-1.4544",
  "storybook-react": "/storybook-react/static-1.33",
  "hub-http-contrib": "/hub-http-contrib/static-1.3071",
  "tinymce-data": "/tinymce-data/static-1.40535",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5240",
  "codemirror": "/codemirror/static-5.95",
  "layout-dnd-components": "/layout-dnd-components/static-1.12498",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11473",
  "react-codemirror": "/react-codemirror/static-1.10655",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15405",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9081",
  "outpost": "/outpost/static-1.4207",
  "flux-actions": "/flux-actions/static-1.341",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13665",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5631",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7811",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10395",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.526",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68525",
  "layout-data-lib": "/layout-data-lib/static-1.9798",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3042",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.322",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.446",
  "slack-ui-library": "/slack-ui-library/static-1.10421",
  "advanced-menus-core": "/advanced-menus-core/static-1.15172",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12110",
  "ExportDialog": "/ExportDialog/static-6.10413",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34125",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15171",
  "simple-menus-lib": "/simple-menus-lib/static-1.16688"
}
};
